import type {
  FinancePaymentMethod,
  ProductPaymentGatewaySettings,
  ProductPaymentMethod,
} from '@/services';

/**
 * A forma aparece no combo "Meio de Pagamento" da proposta?
 *
 * As legadas (sem forma do gateway) aparecem sempre que ativas: o I4Pro as
 * cobra. Uma forma do gateway só aparece com o gateway ativo e a forma ligada —
 * do contrário ninguém a cobraria. É a mesma regra do BFF
 * (`hiddenPaymentMethodCodes`).
 */
export function isShownInProposalCombo(
  method: Pick<ProductPaymentMethod, 'status' | 'gatewayMethod'>,
  gateway: Pick<ProductPaymentGatewaySettings, 'active' | 'enabledMethods'>
): boolean {
  if (method.status === 'INACTIVE') return false;
  if (!method.gatewayMethod) return true;
  if (!gateway.active) return false;
  if (method.gatewayMethod === 'ALL') return true;
  return gateway.enabledMethods.includes(method.gatewayMethod);
}

/** Linhas do catálogo que representam uma forma do gateway — o que cada cartão da tela lista. */
export function catalogRowsForMethod(
  methods: ProductPaymentMethod[],
  gatewayMethod: FinancePaymentMethod
): ProductPaymentMethod[] {
  return methods.filter(method => method.gatewayMethod === gatewayMethod);
}
